<button
  type="button"
  [disabled]="disabled || loading"
  [ngClass]="{
    'cursor-default bg-grey-midGrey': disabled && !loading,
    'bg-white': !disabled || loading,
    'cursor-wait': loading,
  }"
  class="inline-flex w-full items-center justify-center rounded-lg border border-grey-midGrey px-4 py-2 outline-offset-[3px]"
  (click)="handleClick()"
  matRipple
  [matRippleDisabled]="disabled"
  [matTooltip]="buttonTooltip"
  matTooltipPosition="above"
  matTooltipClass="tooltip-above"
>
  @if (loading) {
    <div class="flex size-full items-center justify-center rounded-lg">
      <app-loading class="size-6"></app-loading>
    </div>
  } @else {
    <ng-content select="[prepend]"></ng-content>

    @if (leadingIcon) {
      <mat-icon class="material-icons-outlined mr-2" [class]="leadingIconColor">
        {{ leadingIcon }}
      </mat-icon>
    }
    <span class="self-center text-base font-semibold text-primary">{{
      text
    }}</span>
    @if (trailingIcon) {
      <mat-icon class="material-icons-outlined ml-2 text-primary">{{
        trailingIcon
      }}</mat-icon>
    }
  }
</button>
